import React from 'react';
import { useSelector } from 'react-redux';
import { MainWrapper } from 'mm-ui-components';
import { getSecondaryHeader } from '../../store/secondaryHeader/secondaryHeader.selectors';

interface MainWrapperProps {
  configThemeKey?: string;
}


export const MainWrapperConnected: React.FunctionComponent<MainWrapperProps> = props => {
  const isSecondaryHeaderEnabled = !!useSelector(getSecondaryHeader);
  return <MainWrapper {...{ ...props, isSecondaryHeaderEnabled }} />;
};
